"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
var redux_1 = require("redux");
var redux_devtools_extension_1 = require("redux-devtools-extension");
var redux_thunk_1 = __importDefault(require("redux-thunk"));
var connected_react_router_1 = require("connected-react-router");
var rootReducer_1 = require("./rootReducer");
var matomoMiddleware_1 = require("./middlewares/matomoMiddleware");
var refreshActivityMiddleware_1 = require("./middlewares/refreshActivityMiddleware");
exports.store = redux_1.createStore(rootReducer_1.rootReducer, redux_devtools_extension_1.composeWithDevTools(redux_1.applyMiddleware(redux_thunk_1.default, connected_react_router_1.routerMiddleware(rootReducer_1.history), refreshActivityMiddleware_1.refreshActivityMiddleware, matomoMiddleware_1.matomoMiddleware)));
exports.default = exports.store;
